import {
  TransactionDirection,
  TransactionCategory,
  TransactionStatus,
  TransactionAccount,
  TransactionReason,
  EntryModeType,
} from '@aslanpay/portal-common-lib';

export const TransactionDirectionLabels: Record<TransactionDirection, string> = {
  DEBIT: 'Debit',
  CREDIT: 'Credit',
};

export const SystemOnlyTransactionCategories: TransactionCategory[] = [
  'RESERVE_CUTOFF',
  'SALARY_SAVINGS_RESERVE',
  'DEDUCTION_ADJUSTMENT',
];

export const TransactionCategoryLabels: Record<TransactionCategory, string> = {
  SALARY_ACCRUAL: '💰 Salary accrual',
  SALARY_CUTOFF: '✂️ Salary cutoff',
  PURCHASE: '🛒 Purchase',
  POINTS_REDEMPTION: '🎁 Points redemption',
  DEPOSIT: '⬇️ Deposit',
  WITHDRAW: '⬆️ Withdraw',
  REFUND: '↩️ Refund',
  CHARGEBACK: '⚠️ Chargeback',
  CHARGEBACK_CREDIT: '✅ Chargeback credit',
  CHARGEBACK_DEBIT: '❌ Chargeback debit',
  DEDUCTIONS_CUTOFF: '🔪 Deductions cutoff',
  RESERVE_CUTOFF: '✂️ Reserve cutoff',
  SALARY_RESERVE: '📌 Deductions request',
  SALARY_SAVINGS_RESERVE: '🐖 Savings request',
  DEDUCTION_ADJUSTMENT: '🧾 Deduction adjustment',
  FX_FEE: '💱 FX fee',
};

export const TransactionStatusLabels: Record<TransactionStatus, string> = {
  PENDING: 'Pending',
  SETTLED: 'Settled',
  FAILED: 'Failed',
  EXPIRED: 'Expired',
  REVERSED: 'Reversed',
  DECLINED: 'Declined',
};

export const TransactionAccountLabels: Record<TransactionAccount, string> = {
  REFUND: 'Refund',
  CHARGEBACK: 'Chargeback',
  CASHBACK: 'Cashback',
  SALARY: 'Salary',
  RESERVE: 'Reserve',
};

export const TransactionReasonLabels: Record<TransactionReason, string> = {
  REFUND: 'Refund',
  REPAYMENT: 'Repayment',
  BALANCE_ADJUSTMENT: 'Balance adjustment',
  CHARGEBACK: 'Chargeback',
  PAYMENT: 'Payment',
  GOODWILL: 'Goodwill',
  REIMBURSEMENT: 'Reimbursement',
  OTHER: 'Other',
};

export const TransactionEntryModeLabels: Record<EntryModeType, string> = {
  IRRELEVANT: 'Other',
  MAGSTRIPE: 'Other',
  CONTACTLESS: 'Contactless',
  ECOMM: 'E-commerce',
  RESERVED: 'Other',
  OPTICAL_CODE: 'Other',
  ICC: 'Other',
  CREDENTIAL_ON_FILE: 'Credential On File',
  MOTO: 'MOTO',
  MANUAL: 'Other',
  CARD_PRESENT: 'Other',
  CARD_NOT_PRESENT: 'Other',
  UNKNOWN: 'Other',
};
